// extracted by mini-css-extract-plugin
export default {"instanceForm":"instanceForm---RCQDS"};